import { InquiryCustomCakeSize } from "./InquiryCustomCakeSize.js";

export const customCakePrices = {
	[InquiryCustomCakeSize.Portions12]: 2900,
	[InquiryCustomCakeSize.Portions18]: 4200,
	[InquiryCustomCakeSize.Portions25]: 5200,
	[InquiryCustomCakeSize.Custom]: undefined,
} satisfies Record<InquiryCustomCakeSize, number | undefined>;
